(function () {
  var isLocalPreview = location.hostname === "127.0.0.1" || location.hostname === "localhost";
  var ua = navigator.userAgent || "";
  var isIOS = /iPad|iPhone|iPod/.test(ua) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1) ||
    (isLocalPreview && /(?:\?|&)tr20-ios-sim=1(?:&|$)/.test(location.search));
  var useStackedFallback = isIOS || isLocalPreview;
  var debugEnabled = /(?:\?|&)tr20-debug=1(?:&|$)/.test(location.search);
  var debugValues = {};
  var debugPanel = null;

  function renderDebug() {
    if (!debugEnabled || !document.body) return;
    if (!debugPanel) {
      debugPanel = document.createElement("pre");
      debugPanel.id = "tr20-debug-panel";
      debugPanel.setAttribute("aria-live", "polite");
      debugPanel.style.cssText = "position:fixed;z-index:2147483647;top:72px;left:8px;right:8px;max-height:42vh;overflow:auto;margin:0;padding:10px 12px;border:1px solid rgba(255,255,255,.45);border-radius:8px;background:rgba(0,0,0,.88);color:#9cff57;font:11px/1.35 monospace;white-space:pre-wrap;pointer-events:none";
      document.body.appendChild(debugPanel);
    }
    var lines = ["TR20 DEBUG — captura esta pantalla"];
    Object.keys(debugValues).sort().forEach(function (key) {
      lines.push(key + ": " + debugValues[key]);
    });
    debugPanel.textContent = lines.join("\n");
  }

  function debugSet(key, value) {
    if (!debugEnabled) return;
    debugValues[key] = String(value);
    renderDebug();
  }

  function videoLabel(video) {
    if (video.classList.contains("tr20-origin__boot-video")) return "boot.video";
    if (video.classList.contains("tr20-origin__beat-video")) return "background.video";
    if (video.classList.contains("tr20-layers__video")) {
      var layer = video.closest("[data-layer]");
      return "parts." + (layer ? layer.getAttribute("data-layer") : "video");
    }
    return "video";
  }

  function watchVideo(video) {
    if (!debugEnabled || video.getAttribute("data-tr20-debug-bound")) return;
    video.setAttribute("data-tr20-debug-bound", "1");
    var label = videoLabel(video);
    function report(eventName) {
      var error = video.error ? " error=" + video.error.code : "";
      debugSet(label, eventName + " ready=" + video.readyState + " network=" + video.networkState + " size=" + video.videoWidth + "x" + video.videoHeight + error);
    }
    ["loadstart", "loadedmetadata", "loadeddata", "canplay", "playing", "waiting", "stalled", "suspend", "error"].forEach(function (eventName) {
      video.addEventListener(eventName, function () { report(eventName); });
    });
    report("prepared");
  }

  window.TR20Debug = {
    enabled: debugEnabled,
    set: debugSet,
  };
  debugSet("environment", "ios=" + isIOS + " local=" + isLocalPreview + " viewport=" + window.innerWidth + "x" + window.innerHeight + " dpr=" + (window.devicePixelRatio || 1));

  function compileShader(gl, type, source) {
    var shader = gl.createShader(type);
    gl.shaderSource(shader, source);
    gl.compileShader(shader);
    if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) return null;
    return shader;
  }

  function createStackedRenderer(video, canvas) {
    var label = videoLabel(video) + ".alpha";
    function failedRenderer() { return false; }
    failedRenderer.failed = true;
    var gl = canvas.getContext("webgl", {
      alpha: true,
      antialias: false,
      depth: false,
      premultipliedAlpha: false,
      preserveDrawingBuffer: true,
    }) || canvas.getContext("experimental-webgl");
    if (!gl) {
      debugSet(label, "FAIL context");
      return failedRenderer;
    }
    debugSet(label, "context ok maxTexture=" + gl.getParameter(gl.MAX_TEXTURE_SIZE));
    var vertex = compileShader(gl, gl.VERTEX_SHADER,
      "attribute vec2 p;varying vec2 uv;void main(){uv=p*.5+.5;gl_Position=vec4(p,0.,1.);}");
    var fragment = compileShader(gl, gl.FRAGMENT_SHADER,
      "precision mediump float;varying vec2 uv;uniform sampler2D frame;void main(){" +
      "vec3 rgb=texture2D(frame,vec2(uv.x,.5+uv.y*.5)).rgb;" +
      "float alpha=texture2D(frame,vec2(uv.x,uv.y*.5)).r;" +
      "gl_FragColor=vec4(rgb,alpha);}");
    if (!vertex || !fragment) {
      debugSet(label, "FAIL shader compile");
      return failedRenderer;
    }
    var program = gl.createProgram();
    gl.attachShader(program, vertex);
    gl.attachShader(program, fragment);
    gl.linkProgram(program);
    if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
      debugSet(label, "FAIL program link " + gl.getProgramInfoLog(program));
      return failedRenderer;
    }
    gl.useProgram(program);
    var buffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1,-1, 1,-1, -1,1, 1,1]), gl.STATIC_DRAW);
    var position = gl.getAttribLocation(program, "p");
    gl.enableVertexAttribArray(position);
    gl.vertexAttribPointer(position, 2, gl.FLOAT, false, 0, 0);
    var texture = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, texture);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
    gl.uniform1i(gl.getUniformLocation(program, "frame"), 0);
    var uploadFailures = 0;
    var render = function () {
      if (!video.videoWidth || !video.videoHeight || video.readyState < 2) return false;
      var width = video.videoWidth;
      var height = Math.floor(video.videoHeight / 2);
      if (canvas.width !== width || canvas.height !== height) {
        canvas.width = width;
        canvas.height = height;
        gl.viewport(0, 0, width, height);
      }
      try {
        gl.bindTexture(gl.TEXTURE_2D, texture);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, video);
        gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
        uploadFailures = 0;
        render.failed = false;
        debugSet(label, "painted " + width + "x" + height);
        return true;
      } catch (err) {
        uploadFailures += 1;
        if (uploadFailures >= 3) render.failed = true;
        debugSet(label, "FAIL texImage2D " + (err && err.message ? err.message : err));
        return false;
      }
    };
    return render;
  }

  function bindStackedAlpha(video) {
    if (!useStackedFallback || video.getAttribute("data-stacked-alpha") !== "true") return;
    if (video.getAttribute("data-stacked-bound")) return;
    video.setAttribute("data-stacked-bound", "1");
    video.classList.add("tr20-stacked-alpha-source");
    var canvas = document.createElement("canvas");
    canvas.className = "tr20-stacked-alpha-canvas";
    canvas.setAttribute("aria-hidden", "true");
    video.insertAdjacentElement("afterend", canvas);

    var renderer = null;
    var errorReported = false;
    function reportRendererError() {
      if (errorReported) return;
      errorReported = true;
      video.dispatchEvent(new CustomEvent("tr20:stacked-error"));
    }
    canvas.addEventListener("webglcontextlost", function (event) {
      event.preventDefault();
      renderer = null;
      video.__tr20StackedReady = false;
      debugSet(videoLabel(video) + ".alpha", "FAIL context lost");
      reportRendererError();
    });
    canvas.addEventListener("webglcontextrestored", function () {
      renderer = null;
      debugSet(videoLabel(video) + ".alpha", "context restored");
      draw();
    });
    var draw = function () {
      if (video.readyState < 2) return;
      if (!renderer) renderer = createStackedRenderer(video, canvas);
      var painted = renderer();
      if (!painted && renderer.failed) reportRendererError();
      if (painted && !video.__tr20StackedReady) {
        video.__tr20StackedReady = true;
        video.dispatchEvent(new CustomEvent("tr20:stacked-ready"));
      }
      return painted;
    };
    video.__tr20DrawStackedFrame = draw;
    ["loadeddata", "seeked", "timeupdate", "playing", "ended"].forEach(function (eventName) {
      video.addEventListener(eventName, draw);
    });
    if (typeof video.requestVideoFrameCallback === "function") {
      var onFrame = function () {
        draw();
        video.requestVideoFrameCallback(onFrame);
      };
      video.requestVideoFrameCallback(onFrame);
    }
  }

  function prepare(video) {
    if (!video) return video;
    watchVideo(video);
    var iosSrc = video.getAttribute("data-ios-src") || "";
    var webmSrc = video.getAttribute("data-webm-src") || video.getAttribute("data-src") || "";
    var selected = useStackedFallback && iosSrc ? iosSrc : webmSrc;
    if (selected) video.setAttribute("data-src", selected);
    if (video.hasAttribute("data-eager-src") && selected && video.getAttribute("src") !== selected) {
      video.src = selected;
    }
    if (video.getAttribute("data-lazy-alpha") !== "true") bindStackedAlpha(video);
    return video;
  }

  function activate(video) {
    prepare(video);
    bindStackedAlpha(video);
    debugSet(videoLabel(video) + ".activation", "active");
    return video;
  }

  window.TR20VideoCompat = {
    isIOS: isIOS,
    isLocalPreview: isLocalPreview,
    usesFallback: useStackedFallback,
    prepare: prepare,
    activate: activate,
  };

  document.querySelectorAll("video[data-webm-src], video[data-ios-src]").forEach(prepare);
})();
